import React from 'react';
import contact from '../Assets/Images/contact.jpeg';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Contact = () => {
  return (
    <div className="relative h-full w-full ">
      <div
        className="h-full w-full"
        style={{
          backgroundImage: `url(${contact})`,
          backgroundSize: 'cover',
          backgroundPosition: 'left',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative lg:pl-14 h-full w-full py-10 text-slate-100 ">
          <Container className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full h-full px-4 py-5">
            <div>
              <h2 className="text-3xl mb-2 font-bold">For information & Enquiries</h2>
              <p className='text-base fon'>
                This is for our numerous distributors all over Nigeria and the world at large, please contact us for information and inquiries about our products and services.
              </p>
            </div>
            <div className="flex justify-center items-center">
              <Link to="/contact-us">
                <button className=" text-yellow-500 border-2 border-yellow-500 px-4 py-2 rounded-md hover:bg-yellow-600 hover:text-white">
                Contact us
                </button>
              </Link>
            </div>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default Contact;
